export type DeductionAmounts = {
	perPeriodAmountInCents: number;
	deductedTotalInCents: number;
	remainderDeductions?: { amountInCents: number; count: number };
};

export const allocatePerPeriodAmounts = ({
	totalInCents,
	periodCount,
}: {
	totalInCents: number;
	periodCount: number;
}): number[] => {
	if (periodCount <= 0) {
		return [];
	}

	const base = Math.floor(totalInCents / periodCount);
	const remainder = totalInCents - base * periodCount;

	return Array.from({ length: periodCount }, (_, index) => (index < remainder ? base + 1 : base));
};

export const summarizeDeductionAmounts = ({ amountsInCents }: { amountsInCents: number[] }): DeductionAmounts => {
	const deductedTotalInCents = amountsInCents.reduce((total, amount) => total + amount, 0);
	const highest = amountsInCents.reduce((max, amount) => Math.max(max, amount), 0);
	const lowest = amountsInCents.reduce((min, amount) => Math.min(min, amount), highest);

	if (highest === lowest) {
		return { perPeriodAmountInCents: highest, deductedTotalInCents };
	}

	const highestCount = amountsInCents.filter((amount) => amount === highest).length;
	const lowestCount = amountsInCents.length - highestCount;

	if (lowestCount > highestCount) {
		return {
			perPeriodAmountInCents: lowest,
			deductedTotalInCents,
			remainderDeductions: { amountInCents: highest, count: highestCount },
		};
	}

	return {
		perPeriodAmountInCents: highest,
		deductedTotalInCents,
		remainderDeductions: { amountInCents: lowest, count: lowestCount },
	};
};
